module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{},"de":{"Add meal":"Mahlzeit hinzufügen","What would you like to cook next week?":"Was möchtest du nächste Woche kochen?"}}')
  delete Component.options._Ctor
}
